"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpinInducingAsteroid = void 0;
var Tags_1 = require("../Tags");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var CardRequirements_1 = require("../CardRequirements");
var CardRenderer_1 = require("../render/CardRenderer");
var Card_1 = require("../Card");
var Options_1 = require("../Options");
var SpinInducingAsteroid = (function (_super) {
    __extends(SpinInducingAsteroid, _super);
    function SpinInducingAsteroid() {
        return _super.call(this, {
            cardType: CardType_1.CardType.EVENT,
            name: CardName_1.CardName.SPIN_INDUCING_ASTEROID,
            cost: 16,
            tags: [Tags_1.Tags.SPACE],
            tr: { venus: 2 },
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.venus(10, { max: Options_1.max }); }),
            metadata: {
                cardNumber: '246',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.venus(2);
                }),
                description: 'Venus must be 10% or lower. Raise Venus 2 steps.',
            },
        }) || this;
    }
    SpinInducingAsteroid.prototype.play = function (player) {
        player.game.increaseVenusScaleLevel(player, 2);
        return undefined;
    };
    return SpinInducingAsteroid;
}(Card_1.Card));
exports.SpinInducingAsteroid = SpinInducingAsteroid;
